/*eslint-disable*/

import {
  Flex,
  Link,
  List,
  ListItem,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { useChangeLanguage, useLocale } from "remix-i18next";
import { ClientOnly } from "remix-utils";

const languages = [
  {
    code: "en",
    short: "🇬🇧 EN",
    long: "🇬🇧 English",
  },
  {
    code: "el",
    short: "🇬🇷 EL",
    long: "🇬🇷 Ἑλληνική",
  },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const locale = i18n.resolvedLanguage;
  const language =
    languages.find((l) => l.code === locale || locale?.includes(l.code)) ??
    languages[0];

  return (
    <Menu>
      <MenuButton>{language.short}</MenuButton>
      <MenuList>
        {languages.map((l) => (
          <MenuItem
            key={l.code}
            onClick={() => {
              i18n.changeLanguage(l.code);
            }}
          >
            {l.long}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}

export function FooterComponent() {
  const textColor = useColorModeValue("gray.400", "white");

  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="space-between"
      pb="20px"
    >
      <Text
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb="10px"
      >
        {" "}
        &copy; {new Date().getFullYear()}
        <Link
          mx="3px"
          color={textColor}
          href="https://gotips.co"
          target="_blank"
          fontWeight="700"
        >
          GoTips
        </Link>
      </Text>
      <List
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={{ base: 4, md: 10 }}
        flexDirection="row"
      >
        <ClientOnly>
          {() => (
            <ListItem>
              <LanguageSwitcher />
            </ListItem>
          )}
        </ClientOnly>
        <ListItem>
          <Link
            target="_blank"
            fontWeight="500"
            color={textColor}
            href="https://gotips.co/customer-faq"
          >
            FAQ
          </Link>
        </ListItem>
        <ListItem>
          <Link
            target="_blank"
            fontWeight="500"
            color={textColor}
            href="https://gotips.co/customer-terms"
          >
            Terms and Conditions
          </Link>
        </ListItem>
      </List>
    </Flex>
  );
}
